export interface ChatReducer {
  notifications: number
}

const defaultState: ChatReducer = {
  notifications: 0
}

export default defaultState
